import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { IconClose } from "@ui/icons/IconClose";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { GD } from "src/GD";
import { AquirerListItem } from "./AquirerListItem";

export const AttachAcquirerPopup = () => {
	useLocale();
	const editorRequestData = GD.S_TERMINAL_ATTACH_ACQUIRER_EDITOR.use();

	const [acquirers, _busy] = GD.B_ACQUIRERS.use({ ts: +new Date() });

	if (!editorRequestData) return null;

	const handleSubmit = async () => {
		GD.S_TERMINAL_ATTACH_ACQUIRER_EDITOR.invoke(null);

		// if (!busySave && editorRequestData && editorRequestData.website_id) {
		// 	setSaveError(undefined);
		// 	setBusySave(true);

		// 	const terminalId: number = 1;

		// 	const res = await GD.REQ_ATTACH_TERMINAL.request({
		// 		merchantID: editorRequestData.merchant_id,
		// 		siteId: editorRequestData.website_id,
		// 		terminalId: terminalId,
		// 	});
		// 	if (!res.error) {
		// 		GD.S_TERMINAL_ATTACH_ACQUIRER_EDITOR.invoke(null);
		// 	} else {
		// 		// setSaveError(res.error);
		// 	}

		// 	setBusySave(false);
		// }
	};

	const onSelect = (_a: IAcquirer) => {
		// if (editorRequestData) {
		// 	editorRequestData.onSelect(a);
		// 	GD.S_TERMINAL_ATTACH_ACQUIRER_EDITOR.invoke(null);
		// }
	};

	return (
		<Panel
			sx={{
				width: "90vw",
				maxWidth: "600px",
				height: "80vh",
				padding: "0",
			}}
			decorator="absolute"
			busy={false}
			label={msg("templateAttachAcquirerToTerminalId_891322b9", { v0: editorRequestData.terminalID })}
			onClose={() => GD.S_TERMINAL_ATTACH_ACQUIRER_EDITOR.invoke(null)}>
			<Box
				sx={{
					backgroundColor: "#EEF0F2",

					overflow: "hidden",
					height: "100%",
				}}>
				{acquirers !== undefined && (
					<Box
						sx={{
							height: "100%",
							overflow: "auto",
							borderRadius: "12px",
							padding: "20px",
						}}>
						{acquirers && acquirers.data && acquirers.data.length > 0 && (
							<VBox gap="10px">
								{acquirers.data.map(a => (
									<AquirerListItem key={a.id} onSelect={() => onSelect(a)} acquirer={a} />
								))}
							</VBox>
						)}
					</Box>
				)}
			</Box>

			<Button
				icon={<IconClose />}
				sx={{ position: "absolute", top: "10px", right: "10px" }}
				onClick={() => GD.S_TERMINAL_ATTACH_ACQUIRER_EDITOR.invoke(null)}
			/>
			{/* <Error error={routeResponse?.error} /> */}

			<Spacer grow />

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				{/* <Error error={saveError} /> */}
				<Button
					title={msg("close")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
